/* ============================================================
   Sullios — homepage JS
   Loaded via theme.liquid: {{ 'sullios.js' | asset_url | script_tag }}
   ============================================================ */
(function(){
  'use strict';

  /* ----- Vault modal -----
     Any element with [data-vault-trigger] opens it.
     Any element with [data-vault-close], the backdrop, or Esc closes it.
     Form submit uses the action URL (Omnisend embedded form / custom endpoint)
     ------------------------------------------------------------ */
  function initVaultModal(){
    var modal = document.getElementById('sul-vault-modal');
    if (!modal) return;
    var input = modal.querySelector('input[type=email]');

    function open(){
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
      if (input) setTimeout(function(){ input.focus(); }, 50);
    }
    function close(){
      modal.classList.remove('open');
      modal.classList.remove('success');
      document.body.style.overflow = '';
    }
    function showSuccess(){ modal.classList.add('success'); }

    document.addEventListener('click', function(e){
      var trigger = e.target.closest('[data-vault-trigger]');
      if (trigger){ e.preventDefault(); open(); return; }
      if (e.target.closest('[data-vault-close]')){ e.preventDefault(); close(); return; }
      if (e.target === modal){ close(); }
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && modal.classList.contains('open')) close();
    });

    // If the theme owner uses a JSON endpoint (e.g. Omnisend custom), intercept
    // submit and POST. If they leave the form using the embedded Omnisend
    // form HTML, this handler is a no-op because the form will navigate.
    var form = modal.querySelector('form[data-vault-form]');
    if (form){
      form.addEventListener('submit', function(e){
        var endpoint = form.getAttribute('data-endpoint');
        if (!endpoint) return; // let the form submit normally
        e.preventDefault();
        var email = (input && input.value || '').trim();
        if (!email) return;
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ email: email, source: 'vault-modal' })
        }).then(function(){
          showSuccess();
        }).catch(function(){
          showSuccess(); // fail open — user perceives signup as successful
        });
      });
    }

    // Expose for analytics if needed
    window.SulliosVault = { open: open, close: close };
  }

  /* ----- Dual countdown (drop coming) -----
     Reads target datetime from the section root: [data-public-target] is an ISO
     string. Vault target is computed as 24 hours earlier.
     ------------------------------------------------------------ */
  function initDualCountdown(){
    var roots = document.querySelectorAll('[data-sul-dual-countdown]');
    if (!roots.length) return;
    function pad(n){ return String(n).padStart(2,'0'); }

    roots.forEach(function(root){
      var iso = root.getAttribute('data-public-target');
      if (!iso) return;
      var publicTarget = new Date(iso);
      if (isNaN(publicTarget)) return;
      var leadMs = parseInt(root.getAttribute('data-vault-lead-hours') || '24', 10) * 3600 * 1000;
      var vaultTarget = new Date(publicTarget.getTime() - leadMs);

      function paint(prefix, target){
        var diff = Math.max(0, Math.floor((target - new Date()) / 1000));
        var d = Math.floor(diff/86400); diff -= d*86400;
        var h = Math.floor(diff/3600); diff -= h*3600;
        var m = Math.floor(diff/60); diff -= m*60;
        var s = diff;
        var setVal = function(unit, val){
          var el = root.querySelector('[data-u-'+prefix+'='+unit+']');
          if (el) el.textContent = pad(val);
        };
        setVal('d', d); setVal('h', h); setVal('m', m); setVal('s', s);
      }
      function tick(){ paint('vault', vaultTarget); paint('public', publicTarget); }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ----- Live activity feed (drop live) -----
     Rotates a static list of entries. For real-time orders, swap this for a
     fetch to /apps/your-app/orders or use an app like Fomo/Nudgify.
     ------------------------------------------------------------ */
  function initActivityFeed(){
    var feed = document.querySelector('[data-sul-activity-feed]');
    if (!feed) return;
    var raw = feed.getAttribute('data-entries');
    if (!raw) return;
    var entries;
    try { entries = JSON.parse(raw); } catch (e) { return; }
    if (!Array.isArray(entries) || !entries.length) return;

    var x = 0;
    function render(start){
      var slice = [];
      for (var k = 0; k < 5; k++) slice.push(entries[(start + k) % entries.length]);
      feed.innerHTML = slice.map(function(e){
        return '<li><div class="av ' + (e.av || 'a1') + '">' + (e.i || '?') + '</div>' +
               '<div class="line"><b>' + (e.n || '') + '</b> in ' + (e.c || '') + ' ' + (e.a || 'bought') +
               ' <span class="prod">' + (e.p || '') + '</span></div>' +
               '<div class="time">' + (e.t || '') + '</div></li>';
      }).join('');
    }
    render(0);
    setInterval(function(){ x = (x + 1) % entries.length; render(x); }, 3500);
  }

  /* ----- Init on DOM ready ----- */
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){
      initVaultModal();
      initDualCountdown();
      initActivityFeed();
    });
  } else {
    initVaultModal();
    initDualCountdown();
    initActivityFeed();
  }
})();
